import styles from './Payment.module.css';
import Card from '../../UI/Card';

const Payment = props => {
  return (
    <Card>
      <h2 className={styles.title}>Payment</h2>
      <h3>Coming soon...</h3>
    </Card>
  );
};
export default Payment;
